import { Panel } from "@components/global/new/Panel/Panel";
import { useWatchNetwork } from "@mobx/services/http";
import rackTemplatesStore from "@mobx/store/locations/rackTemplate";
import { DRAGGING_TYPES3, IRackTemplate } from "@mobx/store/locations/types";
import { useScrollByDragging } from "@utils/hooks/useScrollByDragging";
import { Button } from "antd";
import cn from "classnames";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useIntl } from "react-intl";
import RackTemplate from "../RackTemplate";
import styles from "./RackTemplates.module.scss";

export interface IRackTemplatesProps {
  readonly isFlipped: boolean;
  readonly isShown: boolean;
}

const useControl = () => {
  useWatchNetwork(rackTemplatesStore);

  const onCreateRack = () => {
    rackTemplatesStore.showRackModalForCreating();
  };

  return {
    templates: rackTemplatesStore.templates,

    onCreateRack,
  };
};

const RackTemplates = observer((props: IRackTemplatesProps) => {
  const { formatMessage } = useIntl();
  const control = useControl();

  const [dragging, setDragging] = useState<boolean>(false);

  useScrollByDragging(dragging);

  const hasAvailableRacks =
    control.templates && control.templates.length > 0;

  const onDragStart = (
    e: React.DragEvent<HTMLDivElement>,
    item: IRackTemplate
  ) => {
    setDragging(true);
    const data = JSON.stringify(item);
    e.dataTransfer.setData(DRAGGING_TYPES3.AVAILABLE_RACK, data);
  };

  return (
    <Panel className={styles.shelving_wrapper}>
      <div className={cn(styles.shelving)}>
        {hasAvailableRacks ? (
          control.templates?.map((item) => (
            <div
              draggable
              onDragStart={(e) => onDragStart(e, item)}
              onDragEnd={() => setDragging(false)}
              key={item.id}
            >
              <RackTemplate rack={item} />
            </div>
          ))
        ) : (
          <div className={styles.empty}>
            {formatMessage({ id: "location.available_racks.empty" })}
          </div>
        )}
      </div>
      <Button type="primary" className={styles.btn} onClick={control.onCreateRack}>
        {formatMessage({ id: "location.available_racks.create" })}
      </Button>
    </Panel>
  );
});

RackTemplates.displayName = "RackTemplates";

export default RackTemplates;
